import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon10: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#F3123C"
        d="M20 13.5a2.5 2.5 0 0 1-4.499 1.501L4.498 15l-.075.097A2.5 2.5 0 0 1 0 13.5l.001-.094A.364.364 0 0 1 0 13.373V8.5l.007-.145A1.5 1.5 0 0 1 1 7.085V2.003C1 .897 1.897 0 3.003 0H9.5A7.5 7.5 0 0 1 17 7.5a.544.544 0 0 1-.003.057l.583.158a1.964 1.964 0 0 1 1.421 1.887v1.899c.606.456.999 1.182.999 1.999ZM17.5 12a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 17.5 12Zm-15 0a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 2.5 12ZM6.999 1H3.003C2.449 1 2 1.449 2 2.003V7.5a.5.5 0 0 1-.5.5c-.277 0-.5.223-.5.5v3A2.5 2.5 0 0 1 4.95 14h10.1A2.5 2.5 0 0 1 18 11.05l.001-1.448a.963.963 0 0 0-.691-.924l-8.08-2.19A3.024 3.024 0 0 1 7 3.571L6.999 1ZM9.5 1H8v2.571a2.02 2.02 0 0 0 1.492 1.951l6.505 1.764A6.501 6.501 0 0 0 9.5 1Z"
      />
    </Svg>
  )
}
